import { Grid, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import PropTypes from "prop-types";
import React from "react";

const useStyles = makeStyles((theme) => ({
  counterStyle: {
    fontSize: "14px",
    fontWeight: "bold",
    color: "black",
  },
}));

const StandardAllotment = (props) => {
  const classes = useStyles();

  return (
    <>
      {props.dayState.date ? (
        <div data-testid="standard-allotment">
          <Grid
            container
            justifyContent={"flex-end"}
            sx={{ paddingRight: "5px", fontWeight: "normal", fontSize: "16px", color: "primary.swaBlue" }}
          >
            {props.dayState.date.slice(-2)}
          </Grid>
          {(props.dayState.amOrPmCount > 0 || props.dayState.amCount > 0) &&
            (props.dayState.amOrPmCount > 0 ? (
              <Grid
                container
                sx={{
                  display: "flex",
                  justifyContent: "space-around",
                  fontSize: "10px",
                  fontWeight: "bold",
                  color: "primary.swaBlue",
                  textAlign: "center",
                  padding: "10px",
                }}
              >
                <Grid item md={12} sx={{ marginTop: "20px" }}>
                  AM OR PM
                </Grid>
                <Typography component="span" className={classes.counterStyle} style={{ fontSize: "18px" }}>
                  {props.dayState.amOrPmCount}
                </Typography>
              </Grid>
            ) : (
              <Grid
                sx={{
                  textAlign: "center",
                  padding: "10px",
                }}
              >
                <Grid
                  sx={{
                    fontSize: "18px",
                    fontWeight: "bold",
                    marginBottom: "10px",
                  }}
                >
                  {props.dayState.amCount + props.dayState.eitherCount + props.dayState.pmCount}
                </Grid>
                <Grid
                  sx={{
                    display: "flex",
                    justifyContent: "space-around",
                    fontSize: "10px",
                    fontWeight: "bold",
                    color: "primary.swaBlue",
                  }}
                >
                  <Grid>
                    <Grid>AM</Grid>
                    <Typography component="span" className={classes.counterStyle}>
                      {props.dayState.amCount}
                    </Typography>
                  </Grid>
                  <Grid>
                    <Grid>EITHER</Grid>
                    <Typography component="span" className={classes.counterStyle}>
                      {props.dayState.eitherCount}
                    </Typography>
                  </Grid>
                  <Grid>
                    <Grid>PM</Grid>
                    <Typography component="span" className={classes.counterStyle}>
                      {props.dayState.pmCount}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            ))}
        </div>
      ) : (
        <></>
      )}
    </>
  );
};

StandardAllotment.propTypes = {
  dayState: PropTypes.object.isRequired,
};

export default StandardAllotment;
